import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  root: {
    padding: '30px',
  },
  title: {
    fontSize: '3rem',
    margin: '0 0 1rem',
    color: '#02482b',
  },
});
